import _ from 'lodash';
import {capitalize} from '../../utils';

const effectValidationSchemas = require('./effectValidationSchemas.json');
const effectOptionsMapping = require('./effectOptionsMappings.json');
const effectOptionsDefaults = require('./effectOptionsDefaults.json');
const effectNameMappings = require('./effectNameMappings.json');

function getValidationSchemaOfEffect(effect) {
    return _.get(effectValidationSchemas, effect);
}

function getOptionsDefaultsOfEffect(effect) {
    return _.get(effectOptionsDefaults, effect);
}

function getOptionsMappingsOfEffect(effect) {
    return _.get(effectOptionsMapping, effect, effectOptionsMapping.ALL);
}

function getPresetNameOfEffect(effect, suffix, noSuffixPresets) {
    effect = _.get(effectNameMappings, `${effect}.${suffix}`, effect);
    const capitalizedEffect = capitalize(effect);
    //Preset name is the name of the effect that we send to the viewer
    return _.includes(noSuffixPresets, effect) ? capitalizedEffect : `${capitalizedEffect}${suffix}`;
}

export {
    getValidationSchemaOfEffect,
    getOptionsDefaultsOfEffect,
    getOptionsMappingsOfEffect,
    getPresetNameOfEffect
};
